// Main application entry point
import { CalendarScheduler } from './libs/calendar';
import { ViewportUtils } from './libs/viewport';

// Initialize the application
document.addEventListener('DOMContentLoaded', () => {
    new ViewportUtils();
    new CalendarScheduler();
});

// Expose globals for external scripts that might need them
(window as any).app = {
    ViewportUtils,
    CalendarScheduler,
};

// Add error handling for unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
});

// Add error handling for general errors
window.addEventListener('error', (event) => {
  console.error('Global error:', event.error);
});
